export default __webpack_public_path__ + "static/media/purpleAws.12a1dac1.svg";